import { getCookie } from '@ali/arise-h5-utils-cookie';
import sites from '@ali/arise-h5-utils-sites';
import { getQueryParams } from '@ali/arise-h5-utils-qs';
var ua = navigator.userAgent || '';
var urlParams = getQueryParams();
export function isInAliApp() {
  return /AliApp/.test(ua);
}
export function isInAriseApp() {
  return /AliApp\(MRV/i.test(ua);
}
export function isWindVane() {
  var wvVersion = ua.match(/WindVane[/\s](\d+[._]\d+[._]\d+)/);
  if (wvVersion) {
    return true;
  }
  return false;
}
export function getRealVersion(version) {
  var r = version.split('.').reverse();
  r = r.slice(0, 3).reverse();
  return r.join('.');
}
export function getAppInfo() {
  var userAgent = ua.toLowerCase();
  var appInfo = {
    appVersion: '',
    appName: ''
  };
  var appName = '';
  var appVersion = '';
  if (isInAliApp() && userAgent) {
    try {
      var matchResult = userAgent.match(/AliApp\(([a-z-A-Z]{1,20})\/(\d+(\.\d+){0,6})?\)/i);
      if (matchResult && matchResult.length >= 3) {
        appName = matchResult[1];
        // appVersion = getRealVersion(matchResult[2]);
        appVersion = matchResult[2];
      }
    } catch (e) {}
    if (appName) {
      appInfo.appName = appName;
    }
    if (appVersion) {
      appInfo.appVersion = appVersion;
    }
  }
  return appInfo;
}
export function isIos() {
  return /iPad|iPhone|iPod/.test(ua);
}
export function isAndroid() {
  return ua.toLowerCase().indexOf('android') > -1;
}
export function isDaily() {
  var hostname = typeof location === 'object' && location.hostname || '';
  if (!hostname) {
    return false;
  }
  return /127\.0\.0\.1|localhost|daily|waptest|\.test/.test(hostname);
}
export function isPre() {
  var hostname = typeof location === 'object' && location.hostname || '';
  if (!hostname) {
    return false;
  }
  return hostname.indexOf('pre-www-es.dev-arise.lazada.') >= 0 || hostname.indexOf('pre-www-fr.dev-arise.lazada.') >= 0 || hostname.indexOf('pre-wormhole.') >= 0 || hostname.indexOf('pre-www.proyectoarise.es') >= 0 || hostname.indexOf('pre-pages.proyectoarise.es') >= 0 || hostname.indexOf('pre-shop.dev-arise.lazada.com') >= 0 || hostname.indexOf('pre-gsp.dev-arise.lazada.com') >= 0 || hostname.indexOf('pre-shop.proyectoarise.es') >= 0 || hostname.indexOf('pre-gsp.proyectoarise.es') >= 0 || hostname.indexOf('pre-prs.lazada.') >= 0 || hostname.indexOf('pre-workstation.miravia.net') >= 0 || hostname.indexOf('pre-www.miravia.es') >= 0 || hostname.indexOf('pre-sellercenter.miravia.es') >= 0;
}
export function isOnline() {
  return !isDaily() && !isPre();
}
export function isVoyager(regionID) {
  return regionID === 'VN' || regionID === 'SG' || regionID === 'MY' || regionID === 'PH' || regionID === 'ID' || regionID === 'TH';
}
export function isYatra(regionID) {
  return regionID === 'PK' || regionID === 'LK' || regionID === 'BD' || regionID === 'NP' || regionID === 'MM';
}
export function getEntrance() {
  var currentUa = ua.toLocaleLowerCase();
  var entrance = '';
  var getEntrance = currentUa.match(/(gcash|tngkit|truemoney|momo|zalo|paylah|lazlite)/gi);
  if (getEntrance && getEntrance[0]) {
    entrance = getEntrance[0];
  }
  return entrance;
}

/**
 * split hng cookie and get language string and regionID
 * @param {string} hngcookie string link "MY|en-MY|MYR|458"
 */
function splitHngCookie(str) {
  return str ? str.split('|') : [];
}

/**
 * get valid language of this site, because language can be anything
 * @param {string} language
 * @param {string} regionID
 * @return {string} validLanguage
 */
function getValidLanguage(regionID, language) {
  if (regionID === void 0) {
    regionID = '';
  }
  if (language === void 0) {
    language = '';
  }
  regionID = regionID.toLocaleUpperCase();
  var validLanguages = sites[regionID] ? sites[regionID].lang : [];
  if (!Array.isArray(validLanguages)) {
    return language;
  }

  // if language is switchable, check if it's in this enum array
  var lang = '';
  for (var i = 0; i < validLanguages.length; i++) {
    var item = validLanguages[i];
    if (item && item.indexOf(language) > -1) {
      lang = item;
      break;
    }
  }
  if (!lang) {
    lang = validLanguages[0];
  }
  return lang;
}

/**
 * Get regionID and language in browser and web view
 * priority:
 * in web container: [_i18n_] > [g_config] > [domain] > [cookie]
 * if can't get the correct regionID， return SG en
 */
function getEnv(short) {
  if (short === void 0) {
    short = true;
  }
  var regionID = '';
  var language = '';
  var hngCookie = splitHngCookie(getCookie('hng'));

  // try to get from _i18n_ inject by app
  if (typeof window === 'object' && window._i18n_) {
    var i18n = window._i18n_;
    if (typeof i18n === 'string') {
      try {
        i18n = JSON.parse(i18n);
      } catch (e) {}
    }
    if (typeof i18n === 'object') {
      regionID = i18n.regionID;
      language = i18n.language;
    }
  }

  // try to get regionID from domain and get language from cookie
  if (!regionID && typeof location === 'object' && location.hostname) {
    for (var k in sites) {
      var site = sites[k] || {};
      var isDomainMatched = site && site.domain && location.hostname.indexOf(site.domain) > -1;
      var isDevDomainMatched = (site.devDomains || []).some(function (devDomain) {
        return location.hostname.indexOf(devDomain) > -1;
      });
      if (isDomainMatched || isDevDomainMatched) {
        regionID = site.regionID;
        break;
      }
    }
    if (hngCookie.length > 1) {
      language = hngCookie[1];
    }
  }

  // try to get from g_config which is determined by hng cookie
  if (!regionID && window.g_config && typeof window.g_config === 'object') {
    regionID = window.g_config.regionID;
    language = window.g_config.language;
  }

  // try to get from the cookie
  if (!regionID) {
    if (hngCookie.length >= 4) {
      regionID = hngCookie[0];
      language = hngCookie[1];
    }
  }
  regionID = urlParams['wh_regionID'] || regionID || 'es';
  language = getValidLanguage(regionID, language) || 'en';
  if (short) {
    language = language.substring(0, 2);
  }
  return {
    regionID: regionID.toLocaleUpperCase(),
    language: language
  };
}
export default getEnv;